import React from "react";
import Carousel from 'react-bootstrap/Carousel';
import bootstrap from '../../../assets/logo-boostrap.png';
import react from '../../../assets/logo-react.png';
import html from '../../../assets/logo-html.png';
import css from '../../../assets/logo-css.png';
import git from '../../../assets/logo-git.png';
import mongo from '../../../assets/logo-mongodb.png';
import express from '../../../assets/logo-express.png';
import node from '../../../assets/logo-nodejs.png';
import fb from '../../../assets/logo-firsebase.png';
import js from '../../../assets/logo-js.png';
import './CarouselSkills.css';

function CarouselSkills() {
    return (
        <Carousel className="carousel"
          controls={false} // Disable controls
          indicators={false} // Disable indicators
          interval={3000} // Change to your preferred interval in milliseconds
          fade={true} // Optional: Adds a fading transition instead of a sliding one
        >
          <Carousel.Item>
            <img src={react} alt="React" />
          </Carousel.Item>
          <Carousel.Item>
            <img src={bootstrap} alt="Bootstrap" />
          </Carousel.Item>
          <Carousel.Item>
            <img src={js} alt="JavaScript" />
          </Carousel.Item>
          <Carousel.Item>
            <img src={node} alt="Node.js" />
          </Carousel.Item>
          <Carousel.Item>
            <img src={fb} alt="Firebase" />
          </Carousel.Item>
          <Carousel.Item>
            <img src={html} alt="HTML" />
          </Carousel.Item>
          <Carousel.Item>
            <img src={css} alt="CSS" />
          </Carousel.Item>
          <Carousel.Item>
            <img src={git} alt="Git" />
          </Carousel.Item>
          <Carousel.Item>
            <img src={mongo} alt="MongoDB" />
          </Carousel.Item>
          <Carousel.Item>
            <img src={express} alt="Express" />
          </Carousel.Item>
        </Carousel>
      );
}

export default CarouselSkills;
